import * as React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

export const ThemeTestIconFilled = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      sx={{ width: props.width ?? "26px", height: props.height ?? "20px" }}
    >
      <svg
        viewBox="0 0 26 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_13065_31655)">
          <path
            d="M24.0339 2.54199H2.12311C1.73462 2.54199 1.42383 2.85558 1.42383 3.24757V16.8625C1.42383 17.2545 1.73462 17.5681 2.12311 17.5681H23.8785C24.267 17.5681 24.5778 17.2545 24.5778 16.8625V3.24757C24.5778 2.85558 24.267 2.54199 23.8785 2.54199H4.32455"
            fill={props.fill ?? "#2962FF"}
          />
          <path
            d="M24.0339 2.54199H2.12311C1.73462 2.54199 1.42383 2.85558 1.42383 3.24757V16.8625C1.42383 17.2545 1.73462 17.5681 2.12311 17.5681H23.8785C24.267 17.5681 24.5778 17.2545 24.5778 16.8625V3.24757C24.5778 2.85558 24.267 2.54199 23.8785 2.54199H4.32455"
            stroke={props.fill ?? "#2962FF"}
            strokeWidth="0.97"
            strokeMiterlimit="10"
          />
          <path
            d="M5.3418 12.8731L7.33604 7.59433C7.37921 7.49851 7.51734 7.49851 7.5605 7.59433L9.53748 12.8731"
            stroke="white"
            strokeWidth="1.08"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.96484 11.5576H8.926"
            stroke="white"
            strokeWidth="1.08"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.579 8.67443C20.579 9.35388 20.0351 9.90266 19.3617 9.90266C19.025 9.90266 17.8164 9.90266 17.8164 9.90266V7.4375H19.3617C20.0351 7.4375 20.579 7.99499 20.579 8.66572V8.67443Z"
            stroke="white"
            strokeWidth="1.08"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.0546 11.3483C21.0546 12.141 20.4158 12.7943 19.6215 12.7943C19.2331 12.7943 17.8086 12.7943 17.8086 12.7943V9.90234H19.6215C20.4158 9.90234 21.0546 10.5469 21.0546 11.3483Z"
            stroke="white"
            strokeWidth="1.08"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.1318 1.4707L12.293 18.9533"
            stroke="white"
            strokeWidth="1.08"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  );
};
